module.exports = __webpack_public_path__ + "static/media/supportbase.170be547.svg";